// redux/versionSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  currentVersion: localStorage.getItem('lastVersionSeen') || null,
  latestVersion: null,
  newVersionAvailable: false,
  status: 'idle',// 'idle' | 'loading' | 'succeeded' | 'failed'
};

export const fetchLatestVersion = createAsyncThunk(
  'version/fetchLatest',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`/version.json?t=${new Date().getTime()}`);
      if (!response.ok) {
        throw new Error('No se pudo obtener la versión del servidor.');
      }
      const data = await response.json();
      return data.version;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const versionSlice = createSlice({
  name: 'version',
  initialState,
  reducers: {
    setCurrentVersion(state, action) {
      state.currentVersion = action.payload;
      localStorage.setItem('lastVersionSeen', action.payload);
    },
    setNewVersionAvailable(state, action) {
      state.newVersionAvailable = action.payload;
    },
    resetNewVersionAvailable(state) {
      state.newVersionAvailable = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestVersion.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLatestVersion.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.latestVersion = action.payload;

        if (state.currentVersion && state.latestVersion !== state.currentVersion) {
          state.newVersionAvailable = true;
        } else {
          state.newVersionAvailable = false;
          // Actualiza la versión actual si es la primera vez o coincide
          if (!state.currentVersion) {
            state.currentVersion = state.latestVersion;
            localStorage.setItem('lastVersionSeen', state.latestVersion);
          }
        }
      })
      .addCase(fetchLatestVersion.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { setCurrentVersion, setNewVersionAvailable, resetNewVersionAvailable } = versionSlice.actions;

export default versionSlice.reducer;
